import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import styled, {css} from 'styled-components'

export const StyledTreatmentRequestScoreGridItemData = styled(GridItem)(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 2}px 0;
        border-bottom: 1px solid ${palette.neutral['200']};
    `
)

export const StyledTreatmentRequestTotalScore = styled.div(
    ({theme: {typography, spacing, palette}}) => css`
        padding: ${spacing * 2}px ${spacing * 3}px;
        ${typography.textSm}
        color: ${palette.neutral['950']};
        border: 1px solid ${palette.neutral['200']};
        background-color: ${palette.neutral['50']};
        margin-top: ${spacing * 4}px;
        border-radius: 8px;

        & b {
            color: ${palette.neutral['600']};
        }
    `
)
